import type { Theme } from '@mui/material/styles';
import type { SxProps } from '@mui/material/styles';
import { CUSTOM_COLOR_PREFIX } from './constants';
import { pillChipCustomStyles, pillChipRootStyles } from './styles';
import type { CustomPaletteColor, PillButtonFieldProps } from './types';

const getCustomPaletteColor = (theme: Theme, colorName: string): CustomPaletteColor | null => {
  if (!colorName.startsWith(CUSTOM_COLOR_PREFIX)) return null;

  const palette = theme.palette as unknown as Record<string, unknown>;
  const entry = palette[colorName];

  if (!entry || typeof entry !== 'object') return null;

  const maybe = entry as Partial<CustomPaletteColor>;
  if (typeof maybe.light === 'string' && typeof maybe.dark === 'string') {
    return { light: maybe.light, dark: maybe.dark, main: maybe.main };
  }

  return null;
};

export const getPillChipSx = (args: {
  theme: Theme;
  variant: PillButtonFieldProps['variant'];
  chipColor?: string;
  isCustomColor: boolean;
}): SxProps<Theme> => {
  const { theme, variant, chipColor, isCustomColor } = args;

  const custom = isCustomColor && chipColor ? getCustomPaletteColor(theme, chipColor) : null;

  return {
    ...pillChipRootStyles,
    ...(custom ? pillChipCustomStyles(custom, variant) : {}),
  };
};
